import React from "react";
import { Button } from "react-bootstrap";

type Props = {
  cardHeight?: string;
};

const ListUsersSessionMessage: React.FC<Props> = ({ cardHeight }) => {
  return (
    <div
      className="mb-5 mb-xl-8 w-100 table-responsive"
      style={{ height: cardHeight }}
    >
      <div className="card-body pt-0 text-start">
        <div className="d-flex align-items-center bg-light-dark rounded p-2 mb-3">
          <span className="svg-icon svg-icon-warning me-5 ">
            <img
              id="imgUsersBlack"
              src="/media/avatars/300-1.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2 align-items-center">
            <p className="fw-bold m-0 text-hover-primary fs-6">Roberto Adams</p>
          </div>
          <Button className="btn btn-success ms-3 p-2">
            <i className="bi bi-send"></i>
          </Button>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-dark me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-3.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold m-0 text-hover-primary fs-6">Ruan</p>
          </div>
          <Button className="btn btn-success ms-3 p-2">
            <i className="bi bi-send"></i>
          </Button>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-danger me-5">
            <img
              id="imgUsersStudent"
              src="/media/avatars/300-7.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold m-0 text-hover-primary fs-6">Rodrigo</p>
          </div>
          <Button className="btn btn-success ms-3 p-2">
            <i className="bi bi-send"></i>
          </Button>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-primary me-5">
            <img
              id="imgUsersBusiness"
              src="/media/avatars/300-9.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold m-0 text-hover-primary fs-6">Ronã</p>
          </div>
          <Button className="btn btn-success ms-3 p-2">
            <i className="bi bi-send"></i>
          </Button>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-danger me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-1.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold m-0 text-hover-primary fs-6">
              Adriano Strack
            </p>
          </div>
          <Button className="btn btn-success ms-3 p-2">
            <i className="bi bi-send"></i>
          </Button>
        </div>

        <div className="d-flex align-items-center bg-light-dark rounded p-3 mb-3">
          <span className="svg-icon svg-icon-primary me-5">
            <img
              id="imgUsersVisitor"
              src="/media/avatars/300-2.jpg"
              alt="users"
            />
          </span>
          <div className="flex-grow-1 me-2">
            <p className="fw-bold m-0 text-hover-primary fs-6">
              Maria Oliveira
            </p>
          </div>
          <Button className="btn btn-success ms-3 p-2">
            <i className="bi bi-send"></i>
          </Button>
        </div>
      </div>
    </div>
  );
};

export { ListUsersSessionMessage };
